/**
 * Mahéquline custom Hotjar event tracking
 * Fires named events + tags recordings on key product interactions so we can
 * answer "which photos and prints get the most attention".
 *
 * No data is sent anywhere except Hotjar (already loaded on the page).
 * Loaded after the Hotjar tracking code via theme.liquid.
 */
(function() {
  'use strict';

  // Defer until Hotjar is ready so events aren't dropped on first page load.
  function fire(eventName) {
    if (typeof window.hj === 'function') {
      try { window.hj('event', eventName); } catch (e) {}
    }
  }
  function tag(tags) {
    if (typeof window.hj === 'function' && Array.isArray(tags) && tags.length) {
      try { window.hj('tagRecording', tags.slice(0, 10)); } catch (e) {}
    }
  }

  // Helper: pull "first word" from a print/title for clean tagging (e.g. "Mayberry").
  function firstWord(s) {
    if (!s) return '';
    return String(s).trim().split(/\s+/)[0].toLowerCase();
  }

  // Single delegated click handler for the whole page.
  document.addEventListener('click', function(e) {
    var target = e.target;

    // 1. Collection grid product card click
    var gridCard = target.closest('.grid-product');
    if (gridCard) {
      // Inner controls (quick-add, swatches) are handled separately below.
      var clickedSwatch = target.closest('.grid-product__print-swatch');
      var clickedQuick = target.closest('.cart-recs__quick-add, .cart-recs__size');
      if (!clickedSwatch && !clickedQuick) {
        var handle = gridCard.dataset.productHandle || '';
        fire('grid_card_clicked');
        if (handle) tag(['grid:' + handle]);
      }
    }

    // 2. Print swatch under a collection grid card
    var gridSwatch = target.closest('.grid-product__print-swatch');
    if (gridSwatch) {
      var swatchTitle = gridSwatch.getAttribute('title') || '';
      fire('grid_swatch_clicked');
      var fw = firstWord(swatchTitle);
      if (fw) tag(['print:' + fw]);
    }

    // 3. PDP print swatch (the bigger swatch row on product pages)
    var pdpSwatch = target.closest('.print-swatch');
    if (pdpSwatch && !gridSwatch) {
      var pdpSwatchTitle = pdpSwatch.getAttribute('title') || pdpSwatch.dataset.printName || '';
      fire('pdp_swatch_clicked');
      var fwp = firstWord(pdpSwatchTitle);
      if (fwp) tag(['pdp-print:' + fwp]);
    }

    // 4. PDP image gallery — thumbnail click
    var pdpThumb = target.closest('.product__thumb');
    if (pdpThumb) {
      // Find which thumbnail position (1-indexed) was clicked
      var thumbItem = pdpThumb.closest('.product__thumb-item');
      var pos = '';
      if (thumbItem && thumbItem.parentNode) {
        var siblings = Array.prototype.filter.call(
          thumbItem.parentNode.children,
          function(n) { return n.classList && n.classList.contains('product__thumb-item'); }
        );
        var idx = siblings.indexOf(thumbItem);
        if (idx >= 0) pos = String(idx + 1);
      }
      fire('pdp_image_thumbnail_clicked');
      if (pos) tag(['pdp-thumb-pos:' + pos]);
    }

    // 5. PDP image gallery — prev/next arrows (signals user wanted to see another photo)
    var pdpArrow = target.closest('.product__thumb-arrow');
    if (pdpArrow) {
      fire('pdp_image_arrow_clicked');
      tag([pdpArrow.classList.contains('product__thumb-arrow--next') ? 'pdp-arrow:next' : 'pdp-arrow:prev']);
    }

    // 6. Cart drawer — quick-add "+" on a recommendation card
    var cartQuickAdd = target.closest('.cart-recs__quick-add');
    if (cartQuickAdd) {
      fire('cart_quick_add_clicked');
      var qaHandle = cartQuickAdd.dataset.handle || '';
      if (qaHandle) tag(['cart-rec-add:' + qaHandle]);
    }

    // 7. Cart drawer — size pill picked from a recommendation card
    var cartSize = target.closest('.cart-recs__size');
    if (cartSize && !cartSize.classList.contains('cart-recs__size--unavailable')) {
      fire('cart_quick_size_clicked');
      var sizeVal = (cartSize.textContent || '').trim();
      var recItem = cartSize.closest('.cart-recs__item');
      var recHandle = (recItem && recItem.dataset.handle) || '';
      var tags = [];
      if (sizeVal) tags.push('cart-rec-size:' + sizeVal);
      if (recHandle) tags.push('cart-rec-bought:' + recHandle);
      if (tags.length) tag(tags);
    }
  }, { capture: true, passive: true });

  // 8. Hover dwell on collection grid card images (>1.5s = real interest)
  // Logged once per card per page view to avoid event flood.
  var hoverTimer = null;
  var hovered = new WeakSet();
  document.addEventListener('mouseenter', function(e) {
    var card = e.target && e.target.closest && e.target.closest('.grid-product__image-mask');
    if (!card) return;
    if (hovered.has(card)) return;
    hoverTimer = setTimeout(function() {
      hovered.add(card);
      fire('grid_card_hovered_long');
      var product = card.closest('.grid-product');
      var handle = product && product.dataset.productHandle;
      if (handle) tag(['grid-hover:' + handle]);
    }, 1500);
  }, true);
  document.addEventListener('mouseleave', function(e) {
    if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
  }, true);
})();
